// 引入axios
import axios from 'axios';
import {useRouter} from "vue-router";
import store from "@/store";
import {ElMessage} from "element-plus";
import config from '@/config'

// 从环境配置读取API地址
const baseUrl = config.baseURL
const timeout = config.timeout

// 创建axios实例
const httpService = axios.create({
    baseURL: baseUrl,
    timeout: timeout
});



// 添加请求request的拦截器，在发送请求前，先执行第一个方法
httpService.interceptors.request.use(function (config) {
    // 从浏览器的sessionStroage中获取token数据，并设置到请求的配置信息中的头信息中，方便后端获取，验证身份
    config.headers.AUTHORIZATION=window.sessionStorage.getItem('token');
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);//将错误对象进行返回
});

// 添加响应拦截器，该拦截器无实际拦截效果，收到后端响应后，直接放过：return response
httpService.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    if (response.status === 200) {
        return response;
    } else {
        return Promise.reject(response);
    }
    return response;
}, function (error) {
    if (error.response && error.response.status === 401) {
        console.log('Token错误或者过期');
        store.commit('LOGOUT')
        store.commit('REST_TAB')
        localStorage.removeItem('token');
        sessionStorage.clear();
        ElMessage({
            type:'error',
            message:error.response.data.info
        })
        window.location.href="/#/login"
        return
    }
    return Promise.reject(error);
});

/*网络请求部分*/

/*
 * export将该方法导出，可以被外部调用
 * get表示用于处理GET请求
 * url:请求地址
 * params:参数，默认为空
 *
 * */
export function get(url, params = {}) {
    // 创建一个Promise对象，以异步方式进行数据请求
    // resolve用于调用成功后传递数据
    // reject用于调用失败后传递错误信息
    return new Promise((resolve, reject) => {
        //httpService为上文创建的axios对象，传入url、访问方式GET、参数params
        httpService({
            url: url,
            method: 'get',
            params: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

/*
 *  post请求
 *  url:请求地址
 *  params:参数
 * */
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params
        }).then(response => {
            //console.log(response)
            resolve(response);
        }).catch(error => {
            //console.log(error)
            reject(error);
        });
    });
}

/*
 *  delete请求
 *  url:请求地址
 *  params:参数
 * */
export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'delete',
            data: params
        }).then(response => {
            //console.log(response)
            resolve(response);
        }).catch(error => {
            //console.log(error)
            reject(error);
        });
    });
}


/*
 *  文件上传
 *  url:请求地址
 *  params:参数
 * */
export function fileUpload(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params,
            headers: { 'Content-Type': 'multipart/form-data' }//头部申明为流传输，传输文件
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

//获取后端服务地址
export function getServerUrl(){
    return baseUrl;
}

function normalizeBase(url) {
    let normalized = url;
    while (normalized.endsWith('/')) {
        normalized = normalized.slice(0, -1);
    }
    return normalized;
}

export function getMediaBaseUrl() {
    const normalized = normalizeBase(baseUrl);
    return `${normalized}/media/`;
}

export function buildAvatarUrl(filename) {
    const safeName = (filename && filename.trim()) ? filename.trim().replace(/^\/+/, '') : 'default.jpg';
    return `${getMediaBaseUrl()}avatar/${safeName}`;
}

// 导出方法
export default {
    get,
    post,
    del,
    fileUpload,
    getServerUrl,
    getMediaBaseUrl,
    buildAvatarUrl
}

import router from '@/router/index'; // 根据实际情况修改路径
// 新增的 token 检测函数
function checkToken() {
    // console.log(router.currentRoute.value.fullPath)
    const currentRoute = router.currentRoute.value.fullPath;
    if (currentRoute === '/'|| currentRoute === '/login'|| currentRoute === '/app/login'||currentRoute === '/app/index') {
        // console.log('当前路由为 /，不进行 Token 检测');
        return;
    }
    const token = window.sessionStorage.getItem('token');
    if (token) {
        return new Promise((resolve, reject) => {
            //httpService为上文创建的axios对象，传入url、访问方式GET、参数params
            httpService({
                url: 'user/checkToken',
                method: 'get',
            }).then(response => {
                return
            }).catch(error => {
                return
                //第一次登录退出失败，进行过其他操作后，退出就成功
            });
        });
    } else {
        console.log('需要登录');
    }
}

// 每隔 5 秒检测一次 token
setInterval(checkToken, 5000);